import { CartDestinationStatus } from './types';

export const calcDestinationStateList = [
  CartDestinationStatus.INIT,
  CartDestinationStatus.RECALC_RUNNING,
  CartDestinationStatus.RECALC_DONE,
];
